import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ScheduleContributorsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { UpsellContributorsEmptyState } from 'modules/project_management/components/upsells/UpsellContributorsEmptyState'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import ContributorsSchedule from 'modules/project_management/pages/ScheduleContributorsPage/ContributorsSchedule'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

const ContributorsListPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const {
    data: page,
    loading,
    error,
  } = useQuery(ScheduleContributorsPageDocument, {
    variables: {
      companyId: companyId,
      featureIds: [Features.projects_contributors],
    },
  })

  const hasContributorsFeature = !!page?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_contributors
  )?.available

  const canManageProjects = !!page?.projectManagement._policies?.accessManageProjects.can
  const canManageSchedules = hasContributorsFeature && canManageProjects
  const canSeePage = !hasContributorsFeature || canManageSchedules

  return (
    <ResponsivePage.Body
      variant={hasContributorsFeature ? 'fullscreen' : 'wide'}
      loading={loading}
      error={error}
      authorized={canSeePage}
    >
      {hasContributorsFeature ? (
        <ContributorsSchedule />
      ) : (
        <Box alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
          <UpsellContributorsEmptyState
            requestSource={ProjectsUpsellRequestSources.scheduleEmptyState}
            learnMoreNavigate={'/discover/news/calendar-view-in-projects'}
            description={i18n.t('project_management.upselling.schedule')}
          />
        </Box>
      )}
    </ResponsivePage.Body>
  )
}

export default ContributorsListPage
